/**
 * @file
 * Initialize Before/After script for Special paragraph.
 */

const $beforeAfter = $('.cpl-special-before-after', context);

$beforeAfter.once('cpl-before-after-paragraph').each((index, el) => {
  $(el)
    .find('.before-after')
    .imagesCompare();
});
